import { action, computed, makeObservable, observable } from 'mobx';

import {
  DEFAULT_ADMIN_TOP_NAV_ORDER_ARRAY,
  DEFAULT_DISTRICT_ADMIN_PROFILE_MENU_ORDER_ARRAY,
  DEFAULT_DISTRICT_ADMIN_TOP_NAV_ORDER_ARRAY,
  DEFAULT_GENERIC_PROFILE_MENU_ORDER_ARRAY,
  DEFAULT_SCHOOL_ADMIN_PROFILE_MENU_ORDER_ARRAY,
  DEFAULT_SCHOOL_ADMIN_TOP_NAV_ORDER_ARRAY,
  DEFAULT_STUDENT_PROFILE_MENU_ORDER_ARRAY,
  DEFAULT_STUDENT_TOP_NAV_ORDER_ARRAY,
  DEFAULT_TEACHER_PROFILE_MENU_ORDER_ARRAY,
  DEFAULT_TEACHER_TOP_NAV_ORDER_ARRAY
} from '../constants';

import { getSessionStorageItem } from '../utils/session';

export class TopNavManager {
  @observable activeTopNavName = undefined;

  // TODO need to move computed topNavOrderArray values in dynamicSatelliteManager to use these observables instead
  @observable defaultAdminTopNavOrderArray = DEFAULT_ADMIN_TOP_NAV_ORDER_ARRAY;
  @observable districtAdminTopNavOrderArray = DEFAULT_DISTRICT_ADMIN_TOP_NAV_ORDER_ARRAY;
  @observable schoolAdminTopNavOrderArray = DEFAULT_SCHOOL_ADMIN_TOP_NAV_ORDER_ARRAY;
  @observable studentTopNavOrderArray = DEFAULT_STUDENT_TOP_NAV_ORDER_ARRAY;
  @observable teacherTopNavOrderArray = DEFAULT_TEACHER_TOP_NAV_ORDER_ARRAY;

  // TODO: Uncomment to add demo link support for other roles
  // @observable demolinkDistrictAdminTopNavOrderArray = DEFAULT_DISTRICT_ADMIN_TOP_NAV_ORDER_ARRAY;
  // @observable demolinkDistrictAdminMainTopNavId = 'default';
  // @observable demolinkSchoolAdminTopNavOrderArray = DEFAULT_SCHOOL_ADMIN_TOP_NAV_ORDER_ARRAY;
  // @observable demolinkSchoolAdminMainTopNavId = 'default';
  // @observable demolinkStudentTopNavOrderArray = DEFAULT_STUDENT_TOP_NAV_ORDER_ARRAY;
  // @observable demolinkStudentMainTopNavId = 'default';
  @observable demolinkTeacherTopNavOrderArray = DEFAULT_TEACHER_TOP_NAV_ORDER_ARRAY;
  @observable demolinkTeacherMainTopNavId = 'default';

  @observable defaultAdminMainTopNavId = 'default';
  @observable districtAdminMainTopNavId = 'default';
  @observable schoolAdminMainTopNavId = 'default';
  @observable teacherMainTopNavId = 'default';
  @observable studentMainTopNavId = 'default';

  @observable allowAuthKeyTopNavUrlParamAuthentication = false;
  @observable allowAuthKeyTopNavUrlParamAuthenticationFromExternalDashboard = false;
  @observable treatTopNavTabsAsAnchorTags = false;

  @observable allowLoginRedirectUrl = false;
  @observable allowVerificationRedirectUrl = false;

  @observable isTopNavClassMenuOpen = false;
  @observable isTopNavProfileMenuOpen = false;

  @observable showFullNotificationBanner = false;
  @observable allowTopNavEnvelopeNotificationIcon = false;

  @observable hasTopNavProfileMenuAvatarTrigger = true; // can be overridden via satellite index.js
  @observable shouldTriggerProfileMenuOnHover = true; // can be overridden via satellite index.js

  @observable additionalAdminTopNavExternalResources = [];
  @observable additionalTeacherTopNavExternalResources = [];
  @observable additionalStudentTopNavExternalResources = [];

  @observable profileMenuDistrictAdminOrderArray = DEFAULT_DISTRICT_ADMIN_PROFILE_MENU_ORDER_ARRAY;
  @observable profileMenuGenericOrderArray = DEFAULT_GENERIC_PROFILE_MENU_ORDER_ARRAY;
  @observable profileMenuSchoolAdminOrderArray = DEFAULT_SCHOOL_ADMIN_PROFILE_MENU_ORDER_ARRAY;
  @observable profileMenuStudentOrderArray = DEFAULT_STUDENT_PROFILE_MENU_ORDER_ARRAY;
  @observable profileMenuTeacherOrderArray = DEFAULT_TEACHER_PROFILE_MENU_ORDER_ARRAY;

  constructor() {
    makeObservable(this);
  }

  @action clearAll = () => {
    this.activeTopNavName = undefined;
    this.isTopNavClassMenuOpen = false;
    this.isTopNavProfileMenuOpen = false;
  }

  @action setActiveTopNavName = (topNavName) => {
    this.activeTopNavName = topNavName;
  }

  @action setDefaultAdminTopNavOrderArray = (defaultAdminTopNavOrderArray) => {
    this.defaultAdminTopNavOrderArray = defaultAdminTopNavOrderArray;
  }

  @action setDistrictAdminTopNavOrderArray = (districtAdminTopNavOrderArray) => {
    this.districtAdminTopNavOrderArray = districtAdminTopNavOrderArray;
  }

  @action setSchoolAdminTopNavOrderArray = (schoolAdminTopNavOrderArray) => {
    this.schoolAdminTopNavOrderArray = schoolAdminTopNavOrderArray;
  }

  @action setTeacherTopNavOrderArray = (teacherTopNavOrderArray) => {
    this.teacherTopNavOrderArray = teacherTopNavOrderArray;
  }

  @action setStudentTopNavOrderArray = (studentTopNavOrderArray) => {
    this.studentTopNavOrderArray = studentTopNavOrderArray;
  }

  // TODO: Uncomment to add setters for demo link support for other roles
  // @action setDemolinkDistrictAdminTopNavOrderArray = (demolinkDistrictAdminTopNavOrderArray) => {
  //   this.demolinkDistrictAdminTopNavOrderArray = demolinkDistrictAdminTopNavOrderArray;
  // }
  //
  // @action setDemolinkDistrictAdminMainTopNavId = (demolinkDistrictAdminMainTopNavId) => {
  //   this.demolinkDistrictAdminMainTopNavId = demolinkDistrictAdminMainTopNavId;
  // }
  //
  // @action setDemolinkSchoolAdminTopNavOrderArray = (demolinkSchoolAdminTopNavOrderArray) => {
  //   this.demolinkSchoolAdminTopNavOrderArray = demolinkSchoolAdminTopNavOrderArray;
  // }
  //
  // @action setDemolinkSchoolAdminMainTopNavId = (demolinkSchoolAdminMainTopNavId) => {
  //   this.demolinkSchoolAdminMainTopNavId = demolinkSchoolAdminMainTopNavId;
  // }
  //
  // @action setDemolinkStudentTopNavOrderArray = (demolinkStudentTopNavOrderArray) => {
  //   this.demolinkStudentTopNavOrderArray = demolinkStudentTopNavOrderArray;
  // }
  //
  // @action setDemolinkStudentMainTopNavId = (demolinkStudentMainTopNavId) => {
  //   this.demolinkStudentMainTopNavId = demolinkStudentMainTopNavId;
  // }

  @action setDemolinkTeacherTopNavOrderArray = (demolinkTeacherTopNavOrderArray) => {
    this.demolinkTeacherTopNavOrderArray = demolinkTeacherTopNavOrderArray;
  }

  @action setDemolinkTeacherMainTopNavId = (demolinkTeacherMainTopNavId) => {
    this.demolinkTeacherMainTopNavId = demolinkTeacherMainTopNavId;
  }

  @action setDefaultAdminMainTopNavId = (defaultAdminMainTopNavId) => {
    this.defaultAdminMainTopNavId = defaultAdminMainTopNavId;
  }

  @action setDistrictAdminMainTopNavId = (districtAdminMainTopNavId) => {
    this.districtAdminMainTopNavId = districtAdminMainTopNavId;
  }

  @action setSchoolAdminMainTopNavId = (schoolAdminMainTopNavId) => {
    this.schoolAdminMainTopNavId = schoolAdminMainTopNavId;
  }

  @action setTeacherMainTopNavId = (teacherMainTopNavId) => {
    this.teacherMainTopNavId = teacherMainTopNavId;
  }

  @action setStudentMainTopNavId = (studentMainTopNavId) => {
    this.studentMainTopNavId = studentMainTopNavId;
  }

  @action setAllowAuthKeyTopNavUrlParamAuthentication = (allowAuthKeyTopNavUrlParamAuthentication) => {
    this.allowAuthKeyTopNavUrlParamAuthentication = allowAuthKeyTopNavUrlParamAuthentication;
  }

  @action setAllowAuthKeyTopNavUrlParamAuthenticationFromExternalDashboard = (
    allowAuthKeyTopNavUrlParamAuthenticationFromExternalDashboard
  ) => {
    this.allowAuthKeyTopNavUrlParamAuthenticationFromExternalDashboard = allowAuthKeyTopNavUrlParamAuthenticationFromExternalDashboard;
  }

  @action setAllowLoginRedirectUrl = (allowLoginRedirectUrl) => {
    this.allowLoginRedirectUrl = allowLoginRedirectUrl;
  }

  @action setAllowVerificationRedirectUrl = (allowVerificationRedirectUrl) => {
    this.allowVerificationRedirectUrl = allowVerificationRedirectUrl;
  }

  @action setTreatTopNavTabsAsAnchorTags = (treatTopNavTabsAsAnchorTags) => {
    this.treatTopNavTabsAsAnchorTags = treatTopNavTabsAsAnchorTags;
  }

  @action setIsTopNavClassMenuOpen = (isTopNavClassMenuOpen) => {
    this.isTopNavClassMenuOpen = isTopNavClassMenuOpen;
  }

  @action setIsTopNavProfileMenuOpen = (isTopNavProfileMenuOpen) => {
    this.isTopNavProfileMenuOpen = isTopNavProfileMenuOpen;
  }

  @action setShowFullNotificationBanner = (showBanner) => {
    this.showFullNotificationBanner = showBanner;
  };

  @action setAllowTopNavEnvelopeNotificationIcon = (allowTopNavEnvelopeNotificationIcon) => {
    this.allowTopNavEnvelopeNotificationIcon = allowTopNavEnvelopeNotificationIcon;
  }

  @action setHasTopNavProfileMenuAvatarTrigger = (hasTopNavProfileMenuAvatarTrigger) => {
    this.hasTopNavProfileMenuAvatarTrigger = hasTopNavProfileMenuAvatarTrigger;
  }

  @action setShouldTriggerProfileMenuOnHover = (shouldTriggerProfileMenuOnHover) => {
    this.shouldTriggerProfileMenuOnHover = shouldTriggerProfileMenuOnHover;
  }

  /**
   * Set additional external resources for the top navigation bar based on the user type.
   *
   * @param {'admin' | 'teacher' | 'student'} userRole - `'admin' | 'teacher' | 'student'`
   * @param {{
   *   _id: string,
   *   url: string,
   *   className?: string,
   *   navTranslationKey?: string,
   *   navTranslationRolloverKey?: string,
   *   viewSelectionKey?: string
   * }[]} resources - An array of resource objects to add to the top navigation.
   *
   * This data will be used for the **TopNav** `getAdditionalTopNavExternalResources()` methods.
   *
   * Note, via `getAdditionalTopNavExternalResources()`:
   *
   * * `className` will default to `'resources' + _id` if not provided.
   * * `navTranslationKey` will default to `_id` if not provided.
   * * `navTranslationRolloverKey` will default to `undefined` if not provided.
   * * `viewSelectionKey` will default to `'resources'` if not provided.
   *
   * @example
   * setAdditionalTopNavExternalResources('admin', [
   *   { _id: 'documentation', url: 'https://docs.example.com' },
   *   { _id: 'frequentlyAskedQuestions', url: 'https://faq.example.com', navTranslationKey: 'faqLink' }
   * ]);
   */
  @action setAdditionalTopNavExternalResources(userRole, resources) {
    switch (userRole) {
      case 'admin':
        this.additionalAdminTopNavExternalResources = resources;
        break;
      case 'teacher':
        this.additionalTeacherTopNavExternalResources = resources;
        break;
      case 'student':
        this.additionalStudentTopNavExternalResources = resources;
        break;
    }
  }

  @action setProfileMenuDistrictAdminOrderArray = (profileMenuDistrictAdminOrderArray) => {
    this.profileMenuDistrictAdminOrderArray = profileMenuDistrictAdminOrderArray;
  }

  @action setProfileMenuGenericOrderArray = (profileMenuGenericOrderArray) => {
    this.profileMenuGenericOrderArray = profileMenuGenericOrderArray;
  }

  @action setProfileMenuSchoolAdminOrderArray = (profileMenuSchoolAdminOrderArray) => {
    this.profileMenuSchoolAdminOrderArray = profileMenuSchoolAdminOrderArray;
  }

  @action setProfileMenuStudentOrderArray = (profileMenuStudentOrderArray) => {
    this.profileMenuStudentOrderArray = profileMenuStudentOrderArray;
  }

  @action setProfileMenuTeacherOrderArray = (profileMenuTeacherOrderArray) => {
    this.profileMenuTeacherOrderArray = profileMenuTeacherOrderArray;
  }

  @computed get allowDemolinkTopNav() {
    const isDemolinkUser = getSessionStorageItem('isDemolinkUser') === true;
    return isDemolinkUser;
  }
}

export default new TopNavManager();
